import React, { useEffect, useState } from 'react';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import moment from 'moment';
import { intakes } from './data/data';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import KenInputField from '../../../global_components/KenInputField';
import { useHistory } from 'react-router-dom';
import KenLoader from '../../../Components/KenLoader/index';
import KenAutoComplete from '../../../global_components/KenAutoComplete/index';
import KenTextLabel from '../../../global_components/KenTextLabel/index';
import { MultiSelect } from 'react-multi-select-component';
import KenSnackBar from '../../../global_components/KenSnackbar';
import {
  getAcademicFilter,
  postProgramBatchSpecialization,
  getProgramAndTermCampusCombinationBYAcademicProgramId,
  getDataForCourseEnrolment,
} from '../../../Utils/apiServices';
import { multiply } from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    margin: '1rem 0',
    padding: theme.spacing(2),
    minHeight: '80vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.KenColors.kenWhite,

    '& .MuiTextField-root': {
      margin: '0px',
      width: '100%',
    },
  },
  heading: {
    fontSize: 18,
    fontWeight: 700,
    color: '#061938',
    margin: 5,
  },
  TextField: {
    width: '100% !important',
    margin: '0 !important',
    height: '1.1876em',
  },
  textInputField: {
    padding: '4px 10px',
  },
}));
const defaultValues = {
  program: '',
  intake: '',
  course: '',
  startDate: '',
  endDate: '',
  year: '',
  Workingdays: '',
  terms: '',
};
const Program = (props) => {
  const min = 1;
  const max = 10000;
  const classes = useStyles();
  const userDetails = localStorage.getItem('userDetails');
  const [selectedDate, handleDateChange] = useState(new Date());
  const [formValues, setFormValues] = useState(defaultValues);
  const [value, setValue] = React.useState('Online');
  const [values, setValues] = React.useState('');
  const [name, setName] = React.useState('');
  const [courseOptions, setCourseOptions] = React.useState([]);
  const [campusOptions, setCampusOptions] = React.useState([]);
  const [campusData, setCampusData] = React.useState([]);
  const [selectedProgram, setSelectedProgram] = React.useState();
  const [termOption, setTermOption] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [todayError, setTodayError] = React.useState('');
  const [endError, setEndError] = useState('');
  const [durationError, setDurationError] = useState('');
  const [disableSubmit, setDisableSubmit] = React.useState(false);
  const [selected, setSelected] = useState([]);
  const [totalProgramDuration, setTotalProgramDuration] = useState();
  const [exsistingProgramPlans, setExsistingProgramPlans] = useState([]);
  const [exsistingSelectedProgram, setExsistingSelectedProgram] = useState([]);
  const [exsistingYear, setExsistingYear] = useState([]);
  const [pgWeeks, setpgWeeks] = useState();
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const multipleDays = [
    {
      label: 'Monday',
      value: 'Monday',
    },
    {
      label: 'Tuesday',
      value: 'Tuesday',
    },
    {
      label: 'Wednesday',
      value: 'Wednesday',
    },
    {
      label: 'Thursday',
      value: 'Thursday',
    },
    {
      label: 'Friday',
      value: 'Friday',
    },
    {
      label: 'Saturday',
      value: 'Saturday',
    },
    {
      label: 'Sunday',
      value: 'Sunday',
    },
  ];
  const [termCampusList, setTermCampusList] = useState([]);
  const [inputFields, setInputFields] = useState([]);
  const idGenerater = () => {
    let id = Math.random().toString(36).substr(2, 9);
    return id;
  };
  useEffect(() => {
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    if (instituteId) {
      getDataForCourseEnrolment(instituteId)
        .then((res) => {
          let response = Object.values(res?.ProgramPlanForEachAcedemicProgram);
          let allProgramPlans = [];
          if (response.length > 0) {
            response.map((item) => {
              item.map((item2) => {
                allProgramPlans.push(item2.ProgramPlanName);
              });
            });
            setExsistingProgramPlans(allProgramPlans);
          }
        })
        .catch((err) => {});
    }
  }, []);
  useEffect(() => {
    const input = [];
    for (let index = 0; index < formValues.terms; index++) {
      let i = index + 1;
      input.push({
        id: idGenerater(),
        termDuration: 'Term Duration' + ' ' + i + ' (in Weeks)',
        value: '',
        name: 'TermDuration' + i,
      });
    }
    setInputFields(input);
  }, [formValues.terms]);
  const handleTermDuration = (e, index) => {
    let newFormValues = [...inputFields];
    newFormValues[index]['value'] = e.target.value;
    let totalDuration = [];
    inputFields.forEach((item) => {
      if (item.value != '') {
        totalDuration.push(Number(item.value));
      }
    });
    let sumDuration = totalDuration.reduce((b, a) => b + a, 0);
    if (sumDuration > Number(totalProgramDuration)) {
      setDurationError(
        `Sum of term duration cannot exceed ${totalProgramDuration} weeks`
      );
      setDisableSubmit(true);
    } else {
      setInputFields(newFormValues);
      setDurationError('');
      setDisableSubmit(false);
    }
  };
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleInputChange = (e, options) => {
    const { name, value } = e.target;
    if (name === 'workingdays') {
      setSelected(e.target.value);
    }
    if (name === 'program') {
      setExsistingSelectedProgram([]);
      setExsistingYear([]);
      let selectedVal = e.target.value;
      let val = termOption.find((str) => {
        return str.label == selectedVal;
      });
      let AcademicProgram = JSON.stringify({title: val.label, value: val.label})
      sessionStorage.setItem('AcademicProgram', AcademicProgram);
      setSelectedProgram(val);
      let opt = options.filter((item) => {
        if (item.value === selectedVal) {
          return item;
        }
      });

      setpgWeeks(opt[0]?.pgDuration);
      setLoading(true);
      setTermCampusList([]);
      getProgramAndTermCampusCombinationBYAcademicProgramId(opt[0].id)
        .then((res) => {
          let newCampusOption = [];
          let format = [];
          let newData;
          res?.data.map((item) => {
            Object.entries(item.mapOftermCampusCombination).map((comb) => {
              let termNo = comb[1].map((item) => {
                return item.split(' ')[1];
              });
              format.push(`Term ${termNo.join(',')} - ${comb[0]}`);
            });

            newData = format.join(' & ');
            newCampusOption.push({
              title: newData,
              value: item.recordId,
            });
            format.splice(0, format.length);
          });
          setTermCampusList(newCampusOption);
          setLoading(false);
        })
        .catch((err) => {
          setTermCampusList([]);
        });
      if (exsistingProgramPlans) {
        setExsistingYear([]);
        let x = exsistingProgramPlans.filter((item) => {
          return item.split('-')[2] === val.alias;
        });
        setExsistingSelectedProgram(x);
      }
    }
    if (name === 'startDate') {
      // let endDate = moment(formValues.startDate).add(pgWeeks, 'weeks');
      // setFormValues({ ...formValues, endDate: endDate });
      if (!selected.includes(moment(e.target.value).format('dddd'))) {
        handleSnackbarOpen(
          'info',
          'This date does not fall under the selected working days'
        );
      }
      if (
        new Date(e.target.value).getTime() >
        new Date(moment().subtract(1, 'day')).getTime()
      ) {
        setTodayError('');
      } else {
        setTodayError('Selected date cannot be earlier than current date.');
      }
    }
    if (name === 'endDate') {
      if (
        new Date(e.target.value).getTime() >
        new Date(formValues.startDate).getTime()
      ) {
        setEndError('');
      } else {
        setEndError('Selected date cannot be earlier than Start date.');
      }
    }
    if (name === 'year') {
      if (exsistingSelectedProgram) {
        let x = exsistingSelectedProgram.filter((item) => {
          return item.split('-')[0] === String(value);
        });
        setExsistingYear(x);
        setFormValues({ ...formValues, intake: '' });
        sessionStorage.setItem('year', e.target.value);
      }
    }
    if (name === 'intake') {
      if (exsistingYear) {
        let x = exsistingYear.filter((item) => {
          return item.split('-')[1] === String(value);
        });
        if (x.length > 0) {
          setDisableSubmit(true);
          handleSnackbarOpen('info', 'Batch already exsists');
        } else {
          setDisableSubmit(false);
        }
        sessionStorage.setItem('intake', e.target.value);
      }
    }
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const getDayName = (dateStr) => {
    var days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    var d = new Date(dateStr);
    return days[d.getDay()];
  };
  const checkTermDuration = (dt2, dt1) => {
    var diff = (moment(dt2).valueOf() - moment(dt1).valueOf()) / 1000;
    diff /= 60 * 60 * 24 * 7;
    return Math.abs(Math.round(diff));
  };
  useEffect(() => {
    if (formValues.startDate != '' && formValues.endDate != '') {
      let startDate = formValues.startDate;
      let endDate = formValues.endDate;
      if (endDate != 'Invalid date') {
        let programDuration = checkTermDuration(endDate, startDate);
        setTotalProgramDuration(programDuration);
      }
    }
  }, [formValues.startDate, formValues.endDate]);

  useEffect(() => {
    if (selectedProgram) {
      formValues.terms = selectedProgram.value;
      // setFormValues({ ...formValues, terms: selectedProgram.value });
    }
  }, [formValues.terms, selectedProgram]);
  useEffect(() => {
    if (formValues.year && formValues.intake) {
      let fulldate = moment(
        formValues.year &&
          formValues.intake &&
          formValues.year + '-' + formValues.intake + '-' + new Date().getDate()
      ).format('YYYY-MM-DD');
      if (
        new Date(fulldate).getTime() >
        new Date(moment().subtract(1, 'day')).getTime()
      ) {
        setTodayError('');
      } else {
        setTodayError('Selected date cannot be earlier than current date');
      }
      setFormValues({
        ...formValues,
        startDate: fulldate,
      });
    }
  }, [selectedProgram, formValues.year, formValues.intake]);
  useEffect(() => {
    const getEndDate = termOption.filter((items) => {
      return items.label === formValues.program;
    });
    const getMonths =
      parseInt(getEndDate[0]?.durationYear * 12) +
      parseInt(getEndDate[0]?.durationMonth);
    if (formValues.startDate != '') {
      var dur = moment.duration(getMonths, 'Months');
      var m1 = moment(formValues.startDate).add(dur);
      let currentEndDay = moment(m1).format('dddd');
      console.log('Orignal End Date', m1.format('YYYY-MM-DD'));
      if (selected.includes(currentEndDay)) {
        setFormValues({
          ...formValues,
          endDate: m1.format('YYYY-MM-DD'),
        });
      } else {
        handleSnackbarOpen(
          'info',
          'The End Date has been updated to the next working day.'
        );
        let nextDay;
        let daysAdded;
        let updatedDate;
        let convertedDays = selected.map((item) => {
          return moment().day(item).weekday();
        });
        const currentDayInt = moment().day(currentEndDay).weekday();
        const intCheck = convertedDays.some((val) => {
          return val > currentDayInt;
        });
        if (intCheck) {
          nextDay = convertedDays.filter((val) => {
            return val > currentDayInt;
          })[0];
        } else {
          nextDay = Math.min(...convertedDays);
        }
        if (currentDayInt <= nextDay) {
          daysAdded = nextDay - currentDayInt;
          updatedDate = moment(m1).add(daysAdded, 'days');
        } else {
          daysAdded = Number(7) - currentDayInt + nextDay;
          updatedDate = moment(m1).add(daysAdded, 'days');
        }
        setFormValues({
          ...formValues,
          endDate: updatedDate.format('YYYY-MM-DD'),
        });
        console.log('Updated End Date', updatedDate.format('YYYY-MM-DD'));
      }
    }
  }, [formValues.program, formValues.startDate, termOption]);
  const yearDynamic = [];
  for (let i = 0; i <= 3; i++) {
    const year = moment().year() + i;
    yearDynamic.push({
      label: year,
      value: year,
    });
  }
  const dateFormatter = (date) => {
    let dArr = date.split('-');
    return dArr[2] + '/' + dArr[1] + '/' + dArr[0];
  };
  const history = useHistory();
  const handleCampusChange = (e, i) => {
    let key = { term: i, campusName: e.target.value };
    if (
      !campusData.includes((el) => {
        return el.campusName === e.target.value;
      })
    ) {
      setCampusData([...campusData, key]);
    } else {
      let data = [...campusData];
      let index = data.findIndex((el) => {
        return el.campusName === e.target.value;
      });
      data[index] = key;
      setCampusData([...data]);
    }
  };
  const termCampusOptions =
    termCampusList &&
    termCampusList.length > 0 &&
    termCampusList?.map((e) => {
      return { title: e.title, value: e.value };
    });

  React.useEffect(() => {
    setLoading(true);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        let termOption = [];
        let campusOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            label: item,
            value: item,
            id: keyVal.id,
            pgDuration: keyVal.prgDurationInWeeks,
          });
          termOption.push({
            label: item,
            value: keyVal.noOfTerms != 'N/A' ? keyVal.noOfTerms : 1,
            alias: keyVal?.alias,
            durationMonth: keyVal.durationMonth,
            durationYear: keyVal.durationYear,
            id: keyVal.id
          });
        });
        Object.entries(res['Campus']).map(([item, keyVal]) => {
          campusOptions.push({ label: item, value: item });
        });
        setCourseOptions(courseOptions);
        setTermOption(termOption);
        setCampusOptions(campusOptions);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [selectedProgram]);

  const addBatch = () => {
    const workingday = selected.join(';');
    const termduration = inputFields.map((items, index) => {
      const i = `Term ${index + 1}-${items.value}`;
      return i;
    });

    if (
      new Date(formValues.startDate).getTime() >
      new Date(moment().subtract(1, 'day')).getTime()
    ) {
      setTodayError('');
      const campusVal = [];
      campusData.map((item) => {
        campusVal.push(item.value);
      });
      let payload = {
        Program: {
          academicProgramsName: '',
          levelOfAcademicProgram: '',
          duration: {
            year: '',
            months: '',
          },
          numberofTerms: '',

          termduration: '',
        },
        Batch: {
          academicProgramsName: formValues.program,
          batchName: selectedProgram?.alias,
          startDate: dateFormatter(formValues.startDate),
          endDate: dateFormatter(formValues.endDate),
          batchStrength: values,
          year: formValues.year,
          intake: formValues.intake,
          campus: campusVal,
          Workingdays: workingday,
          termDuration: termduration.join(';'),
        },
        Specialization: {
          academicProgramsName: '',
          specializationName: '',
        },
      };
      setLoading(true);
      postProgramBatchSpecialization(payload)
        .then((res) => {
          if (res.success) {
            setLoading(false);

            handleSnackbarOpen('success', `${res.message}`);
            setLoading(false);
            setTimeout(() => {
              history.push({pathname: `/app/current-programmes`});
            }, 1000);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setTodayError('Selected date cannot be earlier than current date');
    }
  };

  const selectTermCampus = (e, value) => {
    setCampusData(value);
  };

  const IntakeDiv = (props = 1) => {
    const count = Number(props);
    return [...Array(count)].map((x, i) => (
      <>
        <Grid item sm={6} xs={12}>
          <KenInputField
            label={`Term ${i + 1}`}
            value={i + 1}
            optionalLabel={false}
            disabled={true}
            // onChange={(item, e) => handleTermChange(item, e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <KenSelectWrap
            name="Campus"
            label="Campus"
            options={campusOptions}
            // value={selectedCampus}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleCampusChange(e, i + 1)}
            required
          />
        </Grid>
      </>
    ));
  };
  const handleFilters = () => {
    // props.setFilters(formValues);
    // props.setIsFiltered(true);
    setFormValues({
      ...formValues,
      program: '',
      intake: '',
      course: '',
      startDate: '',
      endDate: '',
      year: '',
      Workingdays: '',
      terms: '',
    });
    setSelectedProgram({ alias: '' });
    setValues('');
    setInputFields([
      {
        termDuration: '',
        value: '',
        name: '',
      },
    ]);
    setSelected([]);
    setCampusData([]);
    setCampusOptions([]);
    setTermOption([
      {
        label: '',
        value: '',
        alias: '',
        durationMonth: '',
        durationYear: '',
      },
    ]);
    setTermCampusList([]);
    setTodayError('');
  };
  return (
    <>
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      <Grid container spacing={2} style={{ maxWidth: 600 }}>
        {loading && <KenLoader />}
        <Grid item xs={12} sm={6}>
          <KenSelectWrap
            name="program"
            label="Program"
            options={courseOptions}
            value={formValues.program}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleInputChange(e, courseOptions)}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} className="textInputField">
          <KenInputField
            label="Program Name"
            required
            placeholder="Program Name"
            name="totalDay"
            // onChange={(e) => setName(e.target.value)}
            value={selectedProgram?.alias}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <KenSelectWrap
            name="year"
            label="Starting Year"
            options={yearDynamic}
            value={formValues.year}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleInputChange(e)}
            required
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <KenSelectWrap
            name="intake"
            label="Intake"
            options={intakes}
            value={formValues.intake}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleInputChange(e)}
            required
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <KenSelectWrap
            name="workingdays"
            label="Working days"
            options={multipleDays}
            value={selected}
            onChange={(e) => handleInputChange(e)}
            dropdownColor="#FFFFFF"
            multiple={true}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenDateTimePicker
            name="startDate"
            label={'Start date'}
            value={formValues.startDate}
            type="date"
            required={true}
            onChange={handleInputChange}
          />
          <p style={{ color: 'red', fontSize: '12px' }}>{todayError}</p>
        </Grid>
        <Grid item xs={12} sm={6}>
          <KenDateTimePicker
            name="endDate"
            label="End date"
            value={formValues.endDate}
            type="date"
            required={true}
            defaultValue={formValues.endDate}
            onChange={handleInputChange}
          />
          <p style={{ color: 'red', fontSize: '12px' }}>{endError}</p>
        </Grid>

        <Grid item xs={12} sm={6}>
          <KenInputField
            // name="name"
            label="Intake Strength"
            value={values}
            optionalLabel={false}
            onChange={(e) => {
              if (/^\d+$/.test(e.target.value)) {
                var value = parseInt(e.target.value, 10);
                if (value > max) value = max;
                if (value < min) value = min;
                setValues(value);
              } else {
                setValues('');
              }
            }}
            style={{ fontSize: 12 }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <KenInputField
            // name="name"
            label="No of Terms"
            name="terms"
            value={formValues.terms}
            optionalLabel={false}
            onChange={(e) => handleInputChange(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
        {inputFields.length > 0 &&
          inputFields.map((items, index) => {
            return (
              <Grid item xs={12} sm={6}>
                <KenInputField
                  label={items.termDuration}
                  required={true}
                  placeholder="Term Duration"
                  name={items.name}
                  onChange={(e) => handleTermDuration(e, index)}
                  value={items.value}
                />
                <p style={{ color: 'red', fontSize: '12px' }}>
                  {durationError}
                </p>
              </Grid>
            );
          })}
        <Grid item sm={12} xs={12}>
          <KenAutoComplete
            options={termCampusOptions.length > 0 ? termCampusOptions : []}
            label="Choose campus format"
            variant="outlined"
            value={campusData}
            onChange={(e, value) => selectTermCampus(e, value)}
            required
          />
        </Grid>
        {/* {IntakeDiv(selectedProgram?.value)} */}
        <Grid
          item
          xs={12}
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <Button
            variant="outlined"
            onClick={handleFilters}
            style={{ height: '37px', marginRight: '10px' }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={addBatch}
            disabled={disableSubmit || campusData.length > 0 ? false : true}
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              history.push('/app/current-programmes');
            }}
            style={{ height: '37px', marginLeft: '10px' }}
          >
            Skip
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default Program;
